import { ReactNode, useState } from "react";
import { Alert } from "reactstrap";

interface Props {
  color?: "warning" | "danger" | "success";
  children: ReactNode;
}

export default function AppAlert({ color = "warning", children }: Props) {
  const [showAlert, setShowAlert] = useState(true);

  if (!showAlert) return null;

  return (
    <Alert color={color} className="font-weight-500 position-relative">
      {children}
      <i
        style={{ position: "absolute", top: 0, right: 3, fontSize: 22 }}
        className="mdi mdi-close cursor-pointer"
        onClick={() => setShowAlert(false)}
      />
    </Alert>
  );
}
